import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Alert, Box, CircularProgress } from "@mui/material";
import { buscarApuracaoPorId } from "../../services/api-relatorios.service";
import ApuracaoDetalhe from "./Detalhe";
import ApuracaoDetalheEsocial from "./DetalheEsocial";

/**
 * TXM-336 — dispatcher por `cod_relatorio`/tipo, para a rota
 * `/relatorios/apuracoes/:id/detalhe` servir tanto CONCILIACAO_SPED quanto
 * ESOCIAL sem duplicar a rota. Achado ao implementar: não existia nenhum
 * registry/roteador por tipo neste app — as rotas apontavam direto para o
 * componente SPED (ver frontend.md/relatório de pesquisa desta sessão).
 */
const ApuracaoDetalheDispatcher = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");
  const [tipo, setTipo] = useState(null);

  useEffect(() => {
    let cancelado = false;
    (async () => {
      setLoading(true);
      setErro("");
      try {
        const res = await buscarApuracaoPorId(id);
        if (cancelado) return;
        if (res?.sucesso === false) {
          setErro(res.mensagem || "Apuração não encontrada.");
        } else {
          setTipo(String(res?.tipo ?? res?.apuracao?.tipo ?? "").trim().toUpperCase());
        }
      } catch (e) {
        if (!cancelado) {
          setErro(e?.response?.data?.mensagem || e?.message || "Erro ao consultar apuração.");
        }
      } finally {
        if (!cancelado) setLoading(false);
      }
    })();
    return () => {
      cancelado = true;
    };
  }, [id]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (erro) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{erro}</Alert>
      </Box>
    );
  }

  if (tipo === "ESOCIAL") {
    return <ApuracaoDetalheEsocial />;
  }
  return <ApuracaoDetalhe />;
};

export default ApuracaoDetalheDispatcher;
